/** Internal GHG inventory report prototype — disabled by default. */
export const GHG_INVENTORY_REPORT_ENABLED =
  process.env.REACT_APP_GHG_INVENTORY_REPORT_ENABLED === 'true';

export const GHG_INVENTORY_REPORT_ROUTE = '/internal/ghg-inventory-report';
